import * as React from "react";

export default function usePrevious<T>(value: T): T | undefined {
    const [previous, setPrevious] = React.useState<T>(value);
    React.useEffect(() => {
        setPrevious(value);
    }, [value]);
    return previous;
}
